/* eslint-disable max-len */
/* eslint-disable camelcase */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useTranslation } from 'react-i18next'
import BigButton from './BigButton'
import W2 from '../../../../assets/icons/W2'
import Misc from '../../../../assets/icons/Misc'
import SelfIncome from '../../../../assets/icons/SelfIncome'
import Errors from '../../../Errors'

const useStyles = makeStyles(() => ({
  cardHeader: {
    fontSize: '1.5rem',
    fontWeight: 300,
    margin: '0px auto 1rem',
    color: 'rgb(77, 77, 77)',
  },
  subHeader: {
    fontSize: 17,
    margin: 8,
    color: 'rgb(77, 77, 77)',
  },
  buttonContainer: {
    marginTop: 16,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  optionsContainer: {
    width: '25.5rem',
  },
  card: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    height: '6rem',
    margin: '0.25rem',
    borderRadius: 8,
    transition: 'all 0.175s ease 0s',
    border: '0.0625rem solid rgb(230, 230, 230)',
    cursor: 'pointer',
    '&[aria-selected="true"]': {
      border: '0.0625rem solid rgb(0, 176, 175)',
      boxShadow: 'rgb(0 176 175 / 15%) 0px 0px 0.25rem',
      backgroundColor: 'rgb(240, 251, 251)',
    },
    '&:hover': {
      border: '0.0625rem solid rgb(0, 176, 175)',
      boxShadow: 'rgb(0 176 175 / 15%) 0px 0px 0.25rem',
      backgroundColor: 'rgb(240, 251, 251)',
    },
  },
  text: {
    fontWeight: 400,
    fontSize: '0.715rem',
    letterSpacing: '0.0625rem',
    transition: 'all 0.175s ease 0s',
    lineHeight: '0.8125rem',
    marginTop: '0.625rem',
    color: 'rgb(97, 97, 97)',
    '&[aria-selected="true"]': {
      color: 'rgb(0, 176, 175)',
    },
    '&:hover': {
      color: 'rgb(0, 176, 175)',
    },
  },
  subText: {
    fontWeight: 400,
    fontSize: '0.515rem',
    letterSpacing: '0.0625rem',
    transition: 'all 0.175s ease 0s',
    lineHeight: '0.8125rem',
    marginBottom: '0.625rem',
    color: 'rgb(97, 97, 97)',
    '&[aria-selected="true"]': {
      color: 'rgb(0, 176, 175)',
    },
    '&:hover': {
      color: 'rgb(0, 176, 175)',
    },
  },
}), { name: 'Income' })

export default function Income(props) {
  const { t } = useTranslation()
  const classes = useStyles(props)

  const { setStep, data } = props
  const {
    income_type, set_income_type,
    errors, setErrors,
  } = data

  const clickContinue = () => {
    const errorsToSet = []

    if (!income_type) errorsToSet.push('Selection is required')
    setErrors(errorsToSet)

    if (!errorsToSet.length) {
      setStep(6)
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.cardHeader}>
        {t('What is your primary source of income?')}
      </div>
      <div className={classes.subHeader}>
        {t('Select the option that works best for you')}
      </div>
      <div className={classes.optionsContainer}>
        {[
          {
            name: t('EMPLOYED INCOME'),
            sub: t('You receive a W2 for your primary source of income'),
            Icon: () => <W2 />,
          },
          {
            name: t('SELF-EMPLOYED INCOME'),
            sub: t('You receive a 1099 or you own your own company'),
            Icon: () => <SelfIncome />,
          },
          {
            name: t('RETIREMENT / OTHER'),
            sub: t('You receive retirement income, disability income or any other benefits. You may also include W2 income'),
            Icon: () => <Misc />,
          },
        ].map(({ name, sub, Icon }) => (
          <div
            onClick={() => set_income_type(name)}
            aria-selected={income_type === name}
            key={name}
            className={classes.card}
          >
            <div style={{ width: 48, height: 48 }}>
              <Icon />
            </div>
            <div aria-selected={income_type === name} className={classes.text}>
              {name}
            </div>
            <div aria-selected={income_type === name} className={classes.subText}>
              {sub}
            </div>
          </div>
        ))}
      </div>

      <Errors errors={errors} />

      <div className={classes.buttonContainer}>
        <BigButton onClick={clickContinue} label={t('Continue')} />
      </div>
    </div>
  )
}
